import {
  ErrorHandler,
  NgModule,
  isDevMode,
  provideAppInitializer,
  inject,
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { HeaderComponent } from './shared/components/header/header.component';
import { FooterComponent } from './shared/components/footer/footer.component';
import { AuthModule } from './modules/auth/auth.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { provideHttpClient } from '@angular/common/http';
import { MatNativeDateModule } from '@angular/material/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslatePipe } from './pipes/translate.pipe';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { DrawerMenuComponent } from './shared/components/drawer-menu/drawer-menu.component';
import { PostHogErrorHandler } from './posthog-error-handler';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
import { ServiceWorkerModule } from '@angular/service-worker';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { ConfigurationService } from './shared/configuration/configuration.service';
import { Capacitor } from '@capacitor/core';

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    HeaderComponent,
    FooterComponent,
    AuthModule,
    MatNativeDateModule,
    MatSidenavModule,
    TranslatePipe,
    MatListModule,
    MatIconModule,
    DrawerMenuComponent,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !Capacitor.isNativePlatform(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    LoaderComponent,
  ],
  providers: [
    provideAnimationsAsync(),
    provideHttpClient(),
    { provide: ErrorHandler, useClass: PostHogErrorHandler },
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: '[data-theme="dark"]',
        },
      },
    }),
    provideAppInitializer(() => {
      const configService = inject(ConfigurationService);
      return new Promise((resolve) => {
        configService
          .getClientId()
          .then(() => configService.initialize())
          .then(() => resolve(true))
          .catch((err) => {
            console.error('App initialization failed:', err);
            resolve(true);
          });
      });
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
